/**
 * ObjectId type constructor
 *
 * ####Example
 *
 *     var id = new mongoose.Types.ObjectId;
 *
 * @constructor ObjectId
 */

'use strict';

module.exports = require('../driver').get().Decimal128;



//////////////////
// WEBPACK FOOTER
// ./~/mongoose/lib/types/decimal128.js
// module id = 366
// module chunks = 0